import { render, staticRenderFns } from "./EditarObraSocial.vue?vue&type=template&id=714ab8fc&"
import script from "./EditarObraSocial.vue?vue&type=script&lang=js&"
export * from "./EditarObraSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports